/* LaVita Lab – Gratis-Geschenke automatisch in den Warenkorb legen / entfernen.
   Darstellung als 0-€-Positionen im Checkout über automatische "Buy X get Y"-Rabatte. */
(function(){
  var GIFT={sachets:57016944755028,shaker:56860265677140,frother:57017058918740};
  var T_SACHETS=1490;   /* ab 14,90 € Magnesium-Warenwert */
  var T_SHAKER=10980;   /* ab 109,80 € Magnesium-Warenwert */
  var GIFT_HANDLES=['lavitalab-shaker-gratis-ab-150','lavitalab-elektrischer-frother','gratis-magnesium-sachets-3-stuck-neukunden-geschenk','shipping-protection'];
  var R=window.routes||{};
  var cartUrl=(R.cart_url||'/cart'), addUrl=(R.cart_add_url||'/cart/add'), changeUrl=(R.cart_change_url||'/cart/change');
  var H={'Content-Type':'application/json','Accept':'application/json'};
  var busy=false;

  function isGiftLine(it){return !!(it.properties&&it.properties._lv_gift);}
  function countsForBase(it){return !isGiftLine(it)&&GIFT_HANDLES.indexOf(it.handle)<0;}
  function getCart(){return fetch(cartUrl+'.js',{credentials:'same-origin'}).then(function(r){return r.json();});}
  function change(payload){return fetch(changeUrl+'.js',{method:'POST',credentials:'same-origin',headers:H,body:JSON.stringify(payload)}).then(function(r){return r.json();});}
  function add(items){return fetch(addUrl+'.js',{method:'POST',credentials:'same-origin',headers:H,body:JSON.stringify({items:items})}).then(function(r){return r.json();});}

  /* Promise<boolean>: true wenn der Warenkorb verändert wurde */
  function sync(){
    if(busy)return Promise.resolve(false);
    busy=true;
    return getCart().then(function(cart){
      var base=0;
      cart.items.forEach(function(it){if(countsForBase(it))base+=it.final_line_price;});
      var want=[];
      if(base>=T_SACHETS)want.push(GIFT.sachets);
      if(base>=T_SHAKER){want.push(GIFT.shaker);want.push(GIFT.frother);}
      var have={},changes=[];
      cart.items.forEach(function(it){
        if(!isGiftLine(it))return;
        if(want.indexOf(it.variant_id)<0||have[it.variant_id]){changes.push({id:it.key,quantity:0});}
        else{have[it.variant_id]=true;if(it.quantity!==1)changes.push({id:it.key,quantity:1});}
      });
      var adds=want.filter(function(v){return !have[v];}).map(function(v){return {id:v,quantity:1,properties:{_lv_gift:'1'}};});
      var p=Promise.resolve();
      changes.forEach(function(c){p=p.then(function(){return change(c);});});
      if(adds.length)p=p.then(function(){return add(adds);});
      return p.then(function(){return changes.length>0||adds.length>0;});
    }).then(function(changed){busy=false;return changed;},function(){busy=false;return false;});
  }
  window.lvGiftsSync=sync;

  /* Auf Warenkorb-Seite / im Drawer: nach jeder Änderung Geschenke abgleichen */
  function onCartContext(){return !!document.querySelector('cart-items,cart-drawer-items,#main-cart-items');}
  function resync(){sync().then(function(changed){if(changed)window.location.reload();});}
  document.addEventListener('DOMContentLoaded',function(){
    if(onCartContext())resync();
    if(typeof window.subscribe==='function'&&window.PUB_SUB_EVENTS&&window.PUB_SUB_EVENTS.cartUpdate){
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,function(){setTimeout(resync,150);});
    }
  });
})();
